// import qs from 'qs';
import request from './request';

// 获取模板主题
export const getTheme = () =>
  request({
    url: 'path/to/gettheme',
    method: 'GET',
  });

//上报错误日志给后端记录
export const createLog = (data: any) =>
  request({
    url: '/carbon-misc/private/user/error/log/create',
    method: 'POST',
    data,
  })
